export const redirectToUrl = (url) => {
    window.location.assign(url);
};
